import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import ProductsErrorsFactory from '../Errors/factory.js'
import ProductsMappersFactory from '../Mappers/factory.js'
import HTTPProductsRepository from './HTTPProductsRepository.js'

export default class ProductsRepositoriesFactory {
  static hTTPProductsRepository = ({config}) =>
    new HTTPProductsRepository({
      config,
      authenticationFetcher: FetcherFactory.httpAuthenticationFetcher({config}),
      productsRawDataToVisibilityProductsListVOMapper:
        ProductsMappersFactory.productsRawDataToVisibilityProductsListVOMapper({
          config
        }),
      productRawDataToProductEntityMapper: ProductsMappersFactory.productRawDataToProductEntityMapper({config}),
      getVisibilityProductsError: ProductsErrorsFactory.getVisibilityProductsError,
      getPaymentAdProductsError: ProductsErrorsFactory.getPaymentAdProductsError
    })
}
